import { Bot, User, Copy, Check, CornerDownRight } from "lucide-react";
import { useState } from "react";
import { AnswerBody, visibleAnswer } from "./AnswerBody";

export const FollowUps = ({ items, onPick, disabled, index }) => {
  if (!items?.length) return null;
  return (
    <div className="mt-3 flex flex-col sm:flex-row sm:flex-wrap gap-2" data-testid={`chat-followups-${index}`}>
      {items.slice(0, 3).map((q, i) => (
        <button key={q} type="button" data-testid={`chat-followup-${index}-${i}`} disabled={disabled} onClick={() => onPick(q)}
          className="text-left rounded-xl border border-cyan-900/60 bg-cyan-500/[0.06] hover:bg-cyan-500/[0.14] hover:border-cyan-600/70 text-cyan-50 px-3.5 py-2.5 text-sm leading-snug flex items-start gap-2 transition-colors disabled:opacity-50 min-h-[44px]">
          <CornerDownRight className="w-4 h-4 text-cyan-300 shrink-0 mt-0.5" /> <span>{q}</span>
        </button>
      ))}
    </div>
  );
};

const fmtTime = (ts) => {
  if (!ts) return "";
  const d = new Date(ts);
  return isNaN(d) ? "" : d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
};

export const ChatMessage = ({ m, index, onFollowUp, busy }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(visibleAnswer(m.content)); setCopied(true); setTimeout(() => setCopied(false), 1500); } catch (e) { console.warn("[apex] copy:", e?.message || e); }
  };

  if (m.role === "user") {
    return (
      <div className="flex justify-end" data-testid={`chat-msg-${index}`}>
        <div className="flex items-end gap-2.5 max-w-[94%] md:max-w-[75%]">
          <div className="rounded-2xl rounded-br-md bg-cyan-500/[0.14] border border-cyan-700/50 text-cyan-50 px-4 py-3 md:px-5 md:py-3.5 text-[1rem] md:text-[1.05rem] leading-7 whitespace-pre-wrap shadow-[0_8px_30px_-16px_rgba(34,211,238,0.5)]">
            {m.content}
          </div>
          <div className="hidden md:flex w-9 h-9 shrink-0 rounded-xl items-center justify-center bg-slate-800 border border-slate-700">
            <User className="w-4 h-4 text-slate-300" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex gap-3 md:gap-4" data-testid={`chat-msg-${index}`}>
      <div className="hidden md:flex w-10 h-10 shrink-0 rounded-xl items-center justify-center bg-cyan-500/15 border border-cyan-900/60 mt-1">
        <Bot className="w-4 h-4 md:w-5 md:h-5 text-cyan-300" />
      </div>
      <div className="min-w-0 flex-1 max-w-full md:max-w-[88%]">
        <div className="flex items-center gap-2 mb-1.5 text-[11px] font-mono-ticker uppercase tracking-widest text-slate-500">
          EV-IDEX {m.ts && <span>· {fmtTime(m.ts)}</span>}
          {!m.streaming && m.content && (
            <button type="button" onClick={copy} data-testid={`chat-copy-${index}`} className="ml-auto inline-flex items-center gap-1 normal-case tracking-normal text-slate-500 hover:text-cyan-200 transition-colors">
              {copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />} {copied ? "Copied" : "Copy"}
            </button>
          )}
        </div>
        <div className="rounded-2xl rounded-tl-md bg-slate-900/80 border border-slate-800 text-slate-200 px-3.5 py-4 md:px-6 md:py-5 text-[1rem] md:text-[1.05rem] leading-7 md:leading-8">
          {m.content ? <AnswerBody text={m.content} streaming={m.streaming} /> : (
            <div className="flex items-center gap-1.5 h-6" data-testid="chat-thinking">
              {[0, 1, 2].map((i) => <span key={i} className="w-2 h-2 rounded-full bg-cyan-400/80 animate-bounce" style={{ animationDelay: `${i * 0.15}s` }} />)}
              <span className="ml-2 text-sm text-slate-400">Checking current EV-IDEX data…</span>
            </div>
          )}
        </div>
        {!m.streaming && m.content && <FollowUps items={m.followups} onPick={onFollowUp} disabled={busy} index={index} />}
      </div>
    </div>
  );
};
